import { render } from "./AddNewStaff.vue?vue&type=template&id=725bfb1c&scoped=true"
import script from "./AddNewStaff.vue?vue&type=script&lang=js"
export * from "./AddNewStaff.vue?vue&type=script&lang=js"

import "./AddNewStaff.vue?vue&type=style&index=0&id=725bfb1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725bfb1c"]])

export default __exports__